class BlogsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.blogs-slider');
    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          0: { 
            slidesPerView: 1.1, 
            spaceBetween: 12 
          },
          480: { 
            slidesPerView: 2, 
            spaceBetween: 16 
          },
          768: { 
            slidesPerView: 2.5, 
            spaceBetween: 20 
          },
          1024: { 
            slidesPerView: 3, 
            spaceBetween: 35 
          }
        }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('blogs-slider', BlogsSlider);